'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBlurOff = function MdBlurOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 22.5c0.5 0 0.9 0.4 0.9 0.9s-0.4 0.7-0.9 0.7-0.9-0.3-0.9-0.7 0.4-0.9 0.9-0.9z m5 5.9c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.6-1.6 1.6-1.6-0.7-1.6-1.6 0.7-1.6 1.6-1.6z m6.6 5.7c0.5 0 0.9 0.4 0.9 0.9s-0.4 0.9-0.9 0.9-0.7-0.4-0.7-0.9 0.3-0.9 0.7-0.9z m-11.6-18.2c0.5 0 0.9 0.3 0.9 0.7s-0.4 0.9-0.9 0.9-0.9-0.4-0.9-0.9 0.4-0.7 0.9-0.7z m5 5.7c0.9 0 1.6 0.8 1.6 1.8s-0.7 1.6-1.6 1.6-1.6-0.7-1.6-1.6 0.7-1.8 1.6-1.8z m25 0.9c0.5 0 0.9 0.4 0.9 0.9s-0.4 0.7-0.9 0.7-0.9-0.3-0.9-0.7 0.4-0.9 0.9-0.9z m-18.4 5.9c1 0 1.8 0.7 1.8 1.6s-0.8 1.6-1.8 1.6-1.6-0.7-1.6-1.6 0.7-1.6 1.6-1.6z m-12.5-19.6l2.2-2.2 27.1 27.2-2.2 2.1-6.3-6.4c0.1 0.2 0.1 0.3 0.1 0.5 0 0.9-0.7 1.6-1.6 1.6s-1.8-0.7-1.8-1.6 0.8-1.6 1.8-1.6c0.1 0 0.3 0 0.4 0l-4.7-4.7c-0.1 1.2-1.2 2.2-2.5 2.2-1.4 0-2.5-1.1-2.5-2.5 0-1.3 1-2.4 2.1-2.5l-4.6-4.7c0 0.1 0 0.3 0 0.4 0 1-0.7 1.8-1.6 1.8s-1.6-0.8-1.6-1.8 0.7-1.6 1.6-1.6l0.5 0.1z m19.3 25.3c0.4 0 0.7 0.4 0.7 0.9s-0.3 0.9-0.7 0.9-0.9-0.4-0.9-0.9 0.4-0.9 0.9-0.9z m6.6-22.5c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.6 1.6-1.6 1.6 0.7 1.6 1.6-0.7 1.6-1.6 1.6z m0 6.8c-0.9 0-1.6-0.8-1.6-1.8s0.7-1.6 1.6-1.6 1.6 0.7 1.6 1.6-0.7 1.8-1.6 1.8z m0 6.6c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.8 1.6-1.8 1.6 0.8 1.6 1.8-0.7 1.6-1.6 1.6z m-13.4-13.4c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.6 1.6-1.6 1.8 0.7 1.8 1.6-0.8 1.6-1.8 1.6z m18.4 5.9c-0.5 0-0.9-0.4-0.9-0.9s0.4-0.7 0.9-0.7 0.9 0.3 0.9 0.7-0.4 0.9-0.9 0.9z m-18.4-11.6c-0.4 0-0.7-0.4-0.7-0.9s0.3-0.9 0.7-0.9 0.9 0.4 0.9 0.9-0.4 0.9-0.9 0.9z m6.8 0c-0.5 0-0.9-0.4-0.9-0.9s0.4-0.9 0.9-0.9 0.7 0.4 0.7 0.9-0.3 0.9-0.7 0.9z m-0.4 13.2c-1.1-0.1-2-1-2.1-2.1v-0.4c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5h-0.4z m0.4-7.5c-1 0-1.8-0.7-1.8-1.6s0.8-1.6 1.8-1.6 1.6 0.7 1.6 1.6-0.7 1.6-1.6 1.6z' })
        )
    );
};

exports.default = MdBlurOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/blur-off.js
// module id = 1290
// module chunks = 168707334958949